import { render, staticRenderFns } from "./TeamsView.vue?vue&type=template&id=38b1b201&"
import script from "./TeamsView.vue?vue&type=script&lang=js&"
export * from "./TeamsView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports